import { render, staticRenderFns } from "./UserUTMTable.vue?vue&type=template&id=62a566c1&scoped=true&"
import script from "./UserUTMTable.vue?vue&type=script&lang=js&"
export * from "./UserUTMTable.vue?vue&type=script&lang=js&"
import style0 from "./UserUTMTable.vue?vue&type=style&index=0&id=62a566c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a566c1",
  null
  
)

export default component.exports